<template>
  <sidebar-item-header class="pc-note__note-details-header" name="noteDetails">笔记详情</sidebar-item-header>
</template>

<script>
import SidebarItemHeader from '@/components/note/sidebar/SidebarItemHeader.vue'

export default {
  components: {
    SidebarItemHeader
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__sidebar.note {
  .pc-note__note-details-header {
    top: 2.6rem;
    bottom: 2.6rem;
  }
}
.pc-note__sidebar.notebook {
  .pc-note__note-details-header {
    top: 5.3rem;
    bottom: 5.3rem;
  }
}

</style>
